import { Button, ButtonProps } from '@repo/atomic-components';
import { classNames } from 'primereact/utils';

export const GreenButton = ({ className, ...props }: ButtonProps) => (
  <Button {...props} className={classNames('!px-4', className)} />
);
